<hlm-dialog-content showCloseButton="false" class="finx-confirm-dialog">
  <div id="web-app" class="p-3 !bg-inherit !rounded-[inherit]">
    <div>
      <p class="mb-1 confirm-dialog-title">{{ dialogCtx.title }}</p>
      <p class="confirm-dialog-content">{{ dialogCtx.content }}</p>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-4">
      <button [class]="negativeButtonClass + ' d-flex buttonText'" (click)="cancel()">
        {{ dialogCtx.negativeText }}
      </button>
      <button [class]="positiveButtonClass + ' d-flex buttonText'" (click)="confirm()">
        {{ dialogCtx.positiveText }}
      </button>
    </div>
  </div>
</hlm-dialog-content>
